import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import * as _ from 'underscore';
import { UserData } from '../shared/service/UserService';

@Injectable()
export class TableService {
    private apiUrl: string;
    private missionConfirmedSource0 = new Subject<string>();
    private missionConfirmedSource1 = new Subject<string>();
    private missionConfirmedSource2 = new Subject<string>();
    private missionConfirmedSource3 = new Subject<string>();
    private missionConfirmedSource4 = new Subject<string>();
    private missionConfirmedSource5 = new Subject<string>();
    private missionConfirmedSource6 = new Subject<string>();
    private missionConfirmedSource7 = new Subject<string>();
    private missionConfirmedSource8 = new Subject<string>();
    private missionConfirmedSource9 = new Subject<string>();
    private missionConfirmedSource10 = new Subject<string>();
    private missionConfirmedSource11 = new Subject<string>();
    private loggedInUserEmail = new Subject<string>();
    missionConfirmed0$ = this.missionConfirmedSource0.asObservable();
    missionConfirmed1$ = this.missionConfirmedSource1.asObservable();
    missionConfirmed2$ = this.missionConfirmedSource2.asObservable();
    missionConfirmed3$ = this.missionConfirmedSource3.asObservable();
    missionConfirmed4$ = this.missionConfirmedSource4.asObservable();
    missionConfirmed5$ = this.missionConfirmedSource5.asObservable();
    missionConfirmed6$ = this.missionConfirmedSource6.asObservable();
    missionConfirmed7$ = this.missionConfirmedSource7.asObservable();
    missionConfirmed8$ = this.missionConfirmedSource8.asObservable();
    missionConfirmed9$ = this.missionConfirmedSource9.asObservable();
    missionConfirmed10$ = this.missionConfirmedSource10.asObservable();
    missionConfirmed11$ = this.missionConfirmedSource11.asObservable();
    loggedInUserEmailID$ = this.loggedInUserEmail.asObservable();
    private header;
    private headerAppJSON;
    constructor(private http: HttpClient) {
        this.apiUrl = UserData.backend_url + '/v1';
        this.header = this.getHeader();
        this.headerAppJSON = this.getHeaderAppJSON();
    }

    public getHeader() {
        let authorizationString = "Bearer " + UserData.token;
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': authorizationString
            })
        };
        return httpOptions;
    }

    public getHeaderAppJSON() {
        let authorizationString = "Bearer " + UserData.token;
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': authorizationString,
                'Content-Type': 'application/json'
            })
        };
        return httpOptions;
    }

    public fetchBaseDetails() {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/bases/';
        return this.http.get(url, this.header);
    }

    public getBase(baseId: any) {
        const url = this.apiUrl + '/bases/' + baseId + '/tables/';
        return this.http.get(url, this.header);
    }

    public createBaseDetails(newBaseData: any) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId)) {
            organizationId = UserData.organizationId;
        }
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/bases/';
        return this.http.post(url, newBaseData, this.header);
    }

    public createTableDetails(baseId: String, newTableData: any) {
        const url = this.apiUrl + '/bases/' + baseId + '/tables/';
        return this.http.post(url, newTableData, this.header);
    }

    public getTableData(tableId: String) {
        const url = this.apiUrl + '/ui/tables/' + tableId;
        return this.http.post(url, this.header);
    }

    public deleteBase(baseId: String) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId)) {
            organizationId = UserData.organizationId;
        }
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/bases/' + baseId;
        return this.http.delete(url, this.header);
    }

    public deleteTable(tableId: String) {
        const url = this.apiUrl + '/tables/' + tableId;
        return this.http.delete(url, this.header);
    }

    public createDuplicateBaseDetails(baseId: String, duplicateBaseData) {
        const url = this.apiUrl + '/bases/duplicateBaseId/' + baseId;
        return this.http.post(url, duplicateBaseData, this.header);
    }

    public createDuplicateTableDetails(baseId: String, tableId: String, duplicateTableData) {
        const url = this.apiUrl + '/bases/' + baseId + '/tables/duplicateTableId/' + tableId;
        return this.http.post(url, duplicateTableData, this.header);
    }

    public saveBaseDescription(baseId: String, baseDescription: any) {
        const url = this.apiUrl + '/saveBaseDescription/' + baseId;
        return this.http.post(url, baseDescription, this.header);
    }

    public saveTableDescription(tableId: String, tableDescription: any) {
        const url = this.apiUrl + '/saveTableDescription/' + tableId;
        return this.http.post(url, tableDescription, this.header);
    }

    public renameTable(tableId: String, newTableName) {
        const url = this.apiUrl + '/tables/' + tableId + '/renameTable/';
        return this.http.put(url, newTableName, this.header);
    }

    public renameBase(baseId: String, newBaseName) {
        const url = this.apiUrl + '/bases/' + baseId + '/renameBase/';
        return this.http.put(url, newBaseName, this.header);
    }

    // *************************Start HandsonTable****************************************************
    public resizeColumn(data, selectedTableId, currentVersionId) {
        const url = this.apiUrl + '/saveColumnWidthVersion?tableId=' + selectedTableId + '&&versionId=' + currentVersionId;
        return this.http.post(url, data, this.headerAppJSON);
    }

    public saveRowData(data, selectedTableId, currentVersionId) {
        const url = this.apiUrl + '/tablesUI/' + selectedTableId + '/versions/' + currentVersionId + '/records';
        return this.http.post(url, data, this.headerAppJSON);
    }

    public saveColData(data, selectedTableId, currentVersionId) {
        const url = this.apiUrl + '/tablesUI/' + selectedTableId + '/versions/' + currentVersionId + '/columns';
        return this.http.post(url, data, this.headerAppJSON);
    }

    public saveDataTypeData(data, selectedTableId, currentVersionId) {
        const url = this.apiUrl + '/tablesUI/' + selectedTableId + '/versions/' + currentVersionId + '/datatype';
        return this.http.post(url, data, this.headerAppJSON);
    }

    public saveTableCellData(data, selectedTableId, currentVersionId) {
        const url = this.apiUrl + '/saveFlexTableDataUIVersion?tableId=' + selectedTableId + '&&versionId=' + currentVersionId;
        return this.http.post(url, data, this.headerAppJSON);
    }

    public saveDataDetailViewCM(data, selectedTableId, currentVersionId) {
        const url = this.apiUrl + '/saveDataDetailViewCM?tableId=' + selectedTableId + '&&versionId=' + currentVersionId;
        return this.http.post(url, data, this.headerAppJSON);
    }

    public saveTableData(data, selectedTableId) {
        const url = this.apiUrl + '/saveFlexTableData?tableId=' + selectedTableId;
        return this.http.post(url, data, this.headerAppJSON);
    }

    public setBaseColor(data, baseId) {
        const url = this.apiUrl + '/saveBaseColor?baseId=' + baseId + "&&color=" + data;
        return this.http.post(url, data, this.headerAppJSON);
    }

    public updateBase(data) {
        const url = this.apiUrl + '/renameAttachment';
        return this.http.post(url, data, this.headerAppJSON);
    }

    public deleteDoc(data, tableId) {
        const url = this.apiUrl + '/deleteFileById/tables/' + tableId;
        return this.http.delete(url, data);
    }

    public deleteMatchGameImage(data, tableId) {
        const url = this.apiUrl + '/deleteFileByIdContentMgt/tables/' + tableId;
        return this.http.post(url, data);
    }

    public copynpasteTableData(data, tableIdFrom, tableIdTo, currentVersionId) {
        let selectUrl = '/copynpasteTableDataVersion?tableIdFrom=' + tableIdFrom + '&&tableIdTo=' + tableIdTo + "&&versionId=" + currentVersionId;
        const url = this.apiUrl + selectUrl;
        return this.http.post(url, data, this.headerAppJSON);
    }

    public dragDropBase(collectionIds: any) {
        const url = this.apiUrl + '/dragndropBases?baseId=' + collectionIds.baseId + '&&baseOrderId=' + collectionIds.baseOrderId;
        return this.http.get(url, this.header);
    }

    public dragDropTable(collectionIds: any) {
        const url = this.apiUrl + '/dragndropTables?baseId=' + collectionIds.baseId + '&&tableId=' + collectionIds.selectedTableId + '&&tableOrderId=' + collectionIds.tableOrderId;
        return this.http.get(url, this.header);
    }

    public saveFile(files) {
        const fd = new FormData();
        for (let i = 0; i < files.length; i++) {
            fd.append("file", files[i], files[i]['name']);
        }
        const url = this.apiUrl + '/saveFlexTableDataFile';
        return this.http.post(url, fd, this.header);
        // const options = new RequestOptions();
        // return this.http.post(url, fd, options);
    }
    public getImageHash(files) :any {
        const fd = new FormData();
        for (let i = 0; i < files.length; i++) {
            fd.append("file", files[i], files[i]['name']);
        }
        const url = this.apiUrl + '/getImageFileHash';
        return this.http.post(url, fd, this.header);
    }

    public downloadFile(data): Observable<Blob> {
        const url = this.apiUrl + '/downloadFile/';
        return this.http.post(url, data, {
            responseType: "blob"
        });
    }

    public deleteRow(tableId, data, currentVersionId) {
        const url = this.apiUrl + '/deleteFlexTableData/' + tableId + '/versions/' + currentVersionId;
        return this.http.post(url, data, this.headerAppJSON);
    }

    confirmMission0(tabIndex: string) {
        this.missionConfirmedSource0.next(tabIndex);
    }

    confirmMission1(isRenameBase: string) {
        this.missionConfirmedSource1.next(isRenameBase);
    }

    confirmMission2(isRenameTable: string) {
        this.missionConfirmedSource2.next(isRenameTable);
    }

    confirmMission3(collectionTables: string) {
        this.missionConfirmedSource3.next(collectionTables);
    }

    confirmMission4(oldTableName: string) {
        this.missionConfirmedSource4.next(oldTableName);
    }

    confirmMission5(tableIDToRename: string) {
        this.missionConfirmedSource5.next(tableIDToRename);
    }

    confirmMission6(basIndex: string) {
        this.missionConfirmedSource6.next(basIndex);
    }

    confirmMission7(Bases: string) {
        this.missionConfirmedSource7.next(Bases);
    }

    confirmMission8(oldBaseName: string) {
        this.missionConfirmedSource8.next(oldBaseName);
    }

    confirmMission9(baseIDToRename: string) {
        this.missionConfirmedSource9.next(baseIDToRename);
    }

    confirmMission10(collectionTables: string) {
        this.missionConfirmedSource10.next(collectionTables);
    }

    confirmMission11(Bases: string) {
        this.missionConfirmedSource11.next(Bases);
    }

    fetchLoggedInUserEmail(userName: string) {
        this.loggedInUserEmail.next(userName);
    }

    public PDFFileNew(practiceSetId): Observable<Blob> {
        let tableBody = [];
        const url = this.apiUrl + '/exportInMultiGamePDF/' + practiceSetId;
        return this.http.post(url, tableBody, {
            responseType: "blob"
        });
    }

    public CSVFileNew(practiceSetId): Observable<Blob> {
        let tableBody = [];
        const url = this.apiUrl + '/exportInMultiGameCSV/' + practiceSetId;
        return this.http.post(url, tableBody, { responseType: "blob" });
    }

    public CSVFileNewForTemplate(practiceSetId): Observable<Blob> {
        let tableBody = [];
        const url = this.apiUrl + '/exportInMultiGameCSV/' + practiceSetId + "?template=true";
        return this.http.post(url, tableBody, { responseType: "blob" });
    }

    public PDFFile(data, colData): Observable<Blob> {
        let tableBody = [];
        tableBody[0] = data;
        tableBody[1] = colData;
        const url = this.apiUrl + '/exportInPDF';
        return this.http.post(url, tableBody, {
            responseType: "blob"
        });
        // const authorizationString = "Bearer " + UserData.token;
        // const headers = new Headers();
        // headers.set('Authorization', authorizationString);
        // headers.set('Content-Type', 'application/json');
        // headers.set('accept', 'application/pdf');
        // let body: any;
        // return this.http.request(new Request({
        //     method: 'POST',
        //     url: url,
        //     body: tableBody,
        //     headers: headers,
        //     responseType: ResponseContentType.Blob
        // }));
    }

    public CSVFile(data, colData, practiceSetId): Observable<Blob> {
        let tableBody = [];
        tableBody[0] = data;
        tableBody[1] = colData;
        const url = this.apiUrl + '/exportInCSV?practiceSetId=' + practiceSetId;
        return this.http.post(url, tableBody, {
            responseType: "blob"
        });
        // const authorizationString = "Bearer " + UserData.token;
        // const headers = new Headers();
        // headers.set('Authorization', authorizationString);
        // headers.set('Content-Type', 'application/json');
        // headers.set('accept', 'application/csv');
        // let body: any;
        // return this.http.request(new Request({
        //     method: 'POST',
        //     url: url,
        //     body: tableBody,
        //     headers: headers,
        //     responseType: ResponseContentType.Blob
        // }));
    }

    // *************************End HandsonTable****************************************************
    // private handleError(error: Response) {
    //     console.error(error);
    //     return Observable.throw(error.json().error || 'Server error');
    // }

    public logout() {
        localStorage.removeItem('currentUser');
    }

    public generateAPIKey(email: string) {
        const url = this.apiUrl + '/generateAPIKey?emailId=' + email;
        return this.http.get(url, this.headerAppJSON);
    }
    public getUserDetails(token) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId)) {
            organizationId = UserData.organizationId;
        }
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/userDetails/';
        return this.http.get(url, this.headerAppJSON);
    }

    public saveImportFile(file) {
        const fd = new FormData();
        fd.append('file', file);
        const url = this.apiUrl + '/importFlexTable';
        return this.http.post(url, fd, this.header);
        // const options = new RequestOptions();
        // return this.http.post(url, fd, options)
        //     .map((response: Response) => <any>response.json())
        //     .catch(this.handleError);
    }

    public saveImportFileContentMgt(file, tableId) {
        const fd = new FormData();
        fd.append('file', file);
        const url = this.apiUrl + '/importCSVContentManagement?tableId=' + tableId;
        return this.http.post(url, fd, this.header);
        // const options = new RequestOptions();
        // return this.http.post(url, fd, options)
        //     .map((response: Response) => <any>response.json())
        //     .catch(this.handleError);
    }


    public fetchUserDetails() {
        const url = this.apiUrl + '/userList/';
        return this.http.get(url, this.header);
    }

    public shareBase(dataToShare, isShare) {
        let url: any = "";
        url = this.apiUrl +  '/shareBaseWithTeam/';
        if (!isShare)
            url = this.apiUrl + '/shareSingleSetWithTeam';
        return this.http.post(url, dataToShare, this.header);
    }

    public shareTouser(dataToShare, isPset) {
        let url: any = "";
        if (!isPset) {
            url = this.apiUrl + '/shareBaseWithUser/';
        } else {
            url = this.apiUrl + '/shareSingleSetWithUser';
        }
        return this.http.post(url, dataToShare, this.header);
    }

    public getBaseCollaborators(baseId: any) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId)) {
            organizationId = UserData.organizationId;
        }
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/baseCollaborators/' + baseId;
        return this.http.get(url, this.header);
    }

    public getPracticeSetCollaborators(baseId: any) {
        const url = this.apiUrl  + '/practiceSetCollaborators/' + baseId;
        return this.http.get(url, this.header);
    }

    public updateBaseCollaboratorRole(dataToBeUpdated) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId)) {
            organizationId = UserData.organizationId;
        }
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/updateBaseCollaboratorRole/';
        return this.http.post(url, dataToBeUpdated, this.header);
    }

    public removeBaseCollaborator(dataToBeUpdated) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId)) {
            organizationId = UserData.organizationId;
        }
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/removeBaseCollaborator/';
        return this.http.post(url, dataToBeUpdated, this.header);
    }

    public sendEmail(dataToShare) {
        const url = this.apiUrl + '/sendEmail/';
        return this.http.post(url, dataToShare, this.header);
    }

    public addVersion(tableId: String) {
        const url = this.apiUrl + '/tables/' + tableId + '/versions';
        return this.http.post(url, this.header);
    }

    public getVersion(tableId: String) {
        const url = this.apiUrl + '/getAllVersions/' + tableId;
        return this.http.get(url, this.header);
    }


    public getVersionData(tableId, versionId) {
        const url = this.apiUrl + '/ui/tables/' + tableId + '/versions/' + versionId;
        return this.http.get(url, this.header);
    }


    public deleteVersion(version) {
        const url = this.apiUrl + '/tables/' + version.table + '/versions/' + version.versionID;
        return this.http.delete(url, this.header);
    }

    public restoreVersion(version) {
        const url = this.apiUrl + '/updateCurrentVersion/' + version.tableId + '/' + version.versionId;
        return this.http.get(url, this.header);
    }

    public getTeams() {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId)) {
            organizationId = UserData.organizationId;
        }
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/teams/?shared=true';
        return this.http.get(url, this.header);
    }

    public saveGames(data, isEditGame) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId)) {
            organizationId = UserData.organizationId;
        }
        organizationId = organizationId == null ? "noOrg" : organizationId;
        if (!isEditGame) {
            const url = this.apiUrl + '/organizations/' + organizationId + '/games/';
            return this.http.post(url, data, this.header);
        }
        else {
            const url = this.apiUrl + '/organizations/' + organizationId + '/games/' + data.id;
            return this.http.put(url, data, this.header);
        }
    }

    public getGames() {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId)) {
            organizationId = UserData.organizationId;
        }
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/gamesUI/';
        return this.http.get(url, this.header);
    }
}
